import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {NgForOf, NgIf} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ItemResponse} from "../../../services/api/item/model";
import {InvoiceCreateRequest, Product} from "../../../services/api/invoice/model";
import {ItemService} from "../../../services/api/item/item.service";
import {InvoiceService} from "../../../services/api/invoice/invoice.service";
import {format_price, invoiceGenerator} from "../../../utils/helper";

@Component({
  selector: 'app-invoice-creator',
  standalone: true,
  imports: [
    MatButton,
    MatIcon,
    NgForOf,
    NgIf,
    ReactiveFormsModule,
    FormsModule
  ],
  templateUrl: './invoice-creator.component.html',
  styleUrl: './invoice-creator.component.css'
})


export class InvoiceCreatorComponent implements OnInit {
  clientName: string = "";
  itemList: ItemResponse[] = []
  filteredItems: ItemResponse[] = [];
  @Output() close = new EventEmitter<void>;

  products: Product[] = [
    {
      uuid: crypto.randomUUID(),
      description: '',
      quantity: 1,
      price: 0,
      showDropDown: false,
      priceType: 'sales_price',
    }
  ];

  constructor(
    private itemService: ItemService,
    private invoiceService: InvoiceService,
  ) {
  }

  ngOnInit() {
    this.getItems();
  }

  getItems() {
    this.itemService.getItems().subscribe(res => {
      this.itemList = res;
    })
  }

  filterItems(item: string) {
    const query = item.toLowerCase();

    if (query) {
      this.filteredItems = this.itemList.filter(item => item.name.toLowerCase().includes(query));
    } else {
      this.filteredItems = [];
    }
  }

  selectItem(item: ItemResponse, index: number) {
    this.products[index].description = item.name;
    const priceType = this.products[index].priceType || 'sales_price';
    this.products[index].price = item[priceType];
    this.filteredItems = [];
    this.products[index].showDropDown = false;
  }

  hideDropdown(index: number) {
    setTimeout(() => {
      this.products[index].showDropDown = false;
    }, 200); // Delay to allow selection before hiding
  }

  openDropdown(index: number) {
    this.products[index].showDropDown = true;

  }

  get total(): number {
    return this.products.reduce((sum, p) => sum + p.quantity * p.price, 0);
  }

  addProduct() {
    this.products.push({
      uuid: crypto.randomUUID(),
      description: '',
      quantity: 1,
      price: 0,
      showDropDown: false,
      priceType: 'sales_price',
    });
  }


  removeProduct(id: string) {
    if (this.products.length > 1) {
      this.products = this.products.filter(p => p.uuid !== id);
    }
  }

  generateInvoice() {
    let requestBody = this.createInvoiceRequest();
    let file = invoiceGenerator(this.clientName, this.products);

    // Send to server
    this.invoiceService.createInvoice(requestBody, file).subscribe(res => {
      console.log(res);
    });
  }

  createInvoiceRequest(): InvoiceCreateRequest {
    return {
      uuid: crypto.randomUUID(),
      client_name: this.clientName,
      products: this.products.map(product => ({
          description: product.description,
          quantity: product.quantity,
          price: product.price,
        }
      ))
    }
  }

  changePriceType(index: number, priceType: 'sales_price' | 'pack_price' | 'piece_price') {
    const product = this.products[index];
    product.priceType = priceType;

    // If a product is already selected, update its price based on the new price type
    if (product.description) {
      const selectedItem = this.itemList.find(item => item.name === product.description);
      if (selectedItem) {
        product.price = selectedItem[priceType];
      }
    }
  }

  protected readonly format_price = format_price;
}
